import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <div class="ns-font-4">Sorry, no products matched the keyword</div>
            <div class="nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
        </div>
    )
}
